import logo from '../../assets/bonotel_logo.svg';

const BonotelLogo = () => {
  return <img src={logo} alt="Bonotel Logo" />;
};

export default BonotelLogo;
